import { Action, createReducer, on } from '@ngrx/store';
import { NotificationActions } from './notification.actions';

/**
 * State of various system wide notifications (e.g. number of unread messages displayed in the top navigation bar)
 */

export interface NotificationState {
    unreadMessages?: number; // Used in TopNavigationBarComponent
}

export const initialNotificationsState: NotificationState = {
    unreadMessages: 0
};

const reducer = createReducer(
    initialNotificationsState,
    on(NotificationActions.webSocketUnreadTwoWayMessagesPushed, (state, payload) => ({
        ...state,
        unreadMessages: (payload as NotificationState).unreadMessages
        // TODO: Refactor so this action only includes unreadMessages and not passing the full NotificationState
    }))
);

// tslint:disable-next-line:only-arrow-functions (AOT required named function - not arrow notation)
export function notificationsStateReducer(state: NotificationState | undefined, action: Action): NotificationState {
    return reducer(state, action);
}
